<script setup>
import { EventManager } from "@events";
import { ref } from "vue";

const props = defineProps({
  rtcId: {
    type: String,
    required: true,
  },
});

// Blocking overlay shown while the camera-swap recovery runs. `persistent` keeps the
// scrim up and prevents the agent from clicking anything underneath or dismissing it.
const dialog = ref(false);
const eventEmitter = EventManager.getEventEmitter(props.rtcId);

eventEmitter.on("recording-recovery-popup-show", () => {
  dialog.value = true;
});

eventEmitter.on("recording-recovery-popup-hide", () => {
  dialog.value = false;
});
</script>

<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent width="auto">
      <v-alert :title="$t('warning')" type="info" icon="mdi-camera-retake">
        <div class="d-flex align-center">
          <v-progress-circular indeterminate size="20" width="2" class="mr-3"></v-progress-circular>
          <span>{{ $t("RecordingRecoveryInProgress") }}</span>
        </div>
      </v-alert>
    </v-dialog>
  </v-row>
</template>
